import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { FaHeart, FaRegHeart, FaStar, FaArrowAltCircleRight } from "react-icons/fa";

function Items() {
    const location = useLocation();
    const [products, setProducts] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [selectedItemName, setSelectedItemName] = useState("");
    const [productModels, setProductModels] = useState({});
    const [selectedModels, setSelectedModels] = useState({});

    const [wishlist, setWishlist] = useState([]);
    const [loadingWishlist, setLoadingWishlist] = useState(true);
    const [selectedVariant, setSelectedVariant] = useState("");

    const { categoryId } = location.state || {};

    const { Name } = location.state || {};
    // const { category } = location.state || {};

    // console.log("categoryid:", categoryId);
    const navigate = useNavigate();

    const customerType = localStorage.getItem("CustomerType");

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const ledname = localStorage.getItem("LedName");
    const ledcode = localStorage.getItem("Ledcode");
    const ledemail = localStorage.getItem("LedEmail");

    // const handleBlur = (productId) => {
    //     handleAddToCart(productId);
    // };

    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };

    const handleAddToCart = (productId) => {
        console.log(productId);
        const product = products.find((p) => p.ID === productId);
        console.log(product);

        if (!product) {
            console.error("❌ Product not found for ID:", productId);
            toast.error("Product not found. Please refresh the page.");
            return;
        }

        addToCart(product);
    };

    const addToCart = async (product) => {
        const quantity = quantities[product.ID];

        if (quantity === "" || !/^\d+$/.test(quantity) || Number(quantity) <= 0) {
            toast.error("Please enter a valid quantity");
            return;
        }

        const qtyNumber = Number(quantity);
        const existingData = JSON.parse(localStorage.getItem("productData")) || [];

        // const index = existingData.findIndex((item) => item.id === product.ID);
        const index = existingData.findIndex((item) => item.id === product.ID && item.selectedVariant === selectedVariant);

        let quantityDifference = qtyNumber;
        let uniqueCode = generateUniqueCode();
        // let uniqueCode = "0";

        if (index !== -1) {
            const updatedQuantity = existingData[index].quantity + qtyNumber;
            if (updatedQuantity > product.Qty) {
                toast.error(`Total quantity exceeds stock (${product.Qty})`);
                return;
            }

            // Keep old code
            uniqueCode = existingData[index].uniqueCode;

            existingData[index].quantity = updatedQuantity;
        } else {
            if (qtyNumber > product.Qty) {
                toast.error(`Available stock is ${product.Qty}`);
                return;
            }

            existingData.push({
                itemName: product.ItemName,
                id: product.ID,
                mop: product.MOP,
                dp: product.DP,
                ap: product.AP,
                mrp: product.MRP,
                branch: product.Branch,
                realpratetax: product.RealPrateTax,
                quantity: qtyNumber,
                uniqueCode,
                selectedVariant, // Track variant in local storage
            });
        }

        // Save to localStorage
        localStorage.setItem("productData", JSON.stringify(existingData));

        const price = getNumericPrice(product);

        // Send to API
        try {
            const payload = {
                itemId: product.ID,
                uniqueCode, // Use the correct one
                itemName: product.ItemName,
                itemPrice: price,
                quantity: quantityDifference,
                ledname,
                ledcode,
                ledemail: ledemail || "no email",
            };
            console.log("Payload to API:", payload);

            const res = await axios.post(`${apiBaseUrl}/cart/add/JAPAN_ACCESORIES`, payload);

            console.log("API Response:", res.data);

            if (res.data.success) {
                toast.success("Item added to cart");
            } else {
                toast.error("Failed to sync with server");
            }
        } catch (err) {
            // console.error("Add to cart error:", err);
            // toast.error("Server error: unable to sync cart");
            console.error("Add to cart error:", err?.response?.data || err.message || err);
            toast.error("Server error: unable to sync cart");
        }

        setQuantities((prev) => ({ ...prev, [product.ID]: "" }));
    };

    const generateUniqueCode = () => {
        return (
            Date.now().toString(36) + // Timestamp in base36
            Math.random().toString(36).substring(2, 8).toUpperCase() // Random 6 chars
        );
    };

    const getNumericPrice = (product) => {
        switch (customerType) {
            case "CUSTOMER":
                return product.MOP ?? product.MRP;
            case "AGENT":
                return product.AP ?? product.MRP;
            case "DEALER":
                return product.DP ?? product.MRP;
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
            case "JS_MANAGER":
            case "TK_MANAGER":
                return product.MRP;
            default:
                return product.MRP;
        }
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await fetch(
                    `${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=${encodeURIComponent(categoryId)}`
                );
                const data = await response.json();
                setProducts(data);
                if (data.length > 0) {
                    setSelectedItemName(data[0].ItemName); // Set the selected item name from the first product
                }
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
    }, [apiBaseUrl, categoryId]);

    // useEffect(() => {
    //     const fetchProducts = async () => {
    //         try {
    //             const response = await fetch(
    //                 `${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=${encodeURIComponent(categoryId)}`
    //             );
    //             if (!response.ok) {
    //                 throw new Error(`HTTP error! status: ${response.status}`);
    //             }
    //             const data = await response.json();
    //             setProducts(data);

    //             // Fetch models for each product
    //             data.forEach(async (product) => {
    //                 try {
    //                     const modelResponse = await fetch(
    //                         `${apiBaseUrl}/getProductByNewFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(
    //                             product.ItemName
    //                         )}`
    //                     );
    //                     if (!modelResponse.ok) {
    //                         throw new Error(`HTTP error! status: ${modelResponse.status}`);
    //                     }
    //                     const modelData = await modelResponse.json();
    //                     const modelOptions = modelData.map((model) => ({ value: model.model, label: model.model }));

    //                     setProductModels((prevModels) => ({
    //                         ...prevModels,
    //                         [product.ID]: modelOptions,
    //                     }));
    //                 } catch (modelError) {
    //                     console.error("Error fetching models:", modelError);
    //                 }
    //             });
    //         } catch (error) {
    //             console.error("Error fetching products or models:", error);
    //         }
    //     };

    //     fetchProducts();
    // }, [apiBaseUrl, categoryId]);

    const handleModelChange = (productId, selectedOption) => {
        setSelectedModels((prevSelectedModels) => ({
            ...prevSelectedModels,
            [productId]: selectedOption,
        }));
    };

    const fullimage = (itemId, ID, customerType) => {
        navigate(`/fullimage/${itemId}/${ID}/${customerType}`);
    };

    const categories = async () => {
        navigate("/categories");
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // const handleQuantityChange = (e, product) => {
    //     const { value } = e.target;
    //     setQuantities({
    //         ...quantities,
    //         [product.ID]: value,
    //     });
    // };

    const handleBlurOrEnter = (e, product) => {
        if (e.type === "blur" || (e.type === "keydown" && e.key === "Enter")) {
            const quantity = quantities[product.ID];
            const selectedModel = selectedModels[product.ID]; // Get the selected model

            if (quantity) {
                if (quantity > product.Qty) {
                    toast.error(`Available stock is ${product.Qty}`);
                    return;
                }

                const savedData = {
                    itemName: product.ItemName,
                    id: product.ID,
                    mop: product.MOP,
                    dp: product.DP,
                    branch: product.Branch,
                    realpratetax: product.RealPrateTax,
                    quantity,
                    selectedModel: selectedModel ? selectedModel.value : null, // Save the selected model value
                };

                const existingData = JSON.parse(localStorage.getItem("productData")) || [];
                const index = existingData.findIndex((item) => item.id === product.ID);

                if (index !== -1) {
                    existingData[index] = savedData;
                } else {
                    existingData.push(savedData);
                }

                localStorage.setItem("productData", JSON.stringify(existingData));

                setQuantities((prevQuantities) => ({
                    ...prevQuantities,
                    [product.ID]: "",
                }));

                setSelectedModels((prevSelectedModels) => ({
                    ...prevSelectedModels,
                    [product.ID]: null, // Clear the selected model after saving
                }));

                toast.success("Item added to cart");
            }
        }
    };

    const renderPriceInfo = (product) => {
        if (!customerType) {
            return <span id="h3">MRP: ₹ {product.MRP}</span>;
        }

        switch (customerType) {
            case "CUSTOMER":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                        {/* <div>
                            <span className="text-[#d1d5db] font-normal text-sm">₹ </span>
                            <span className="text-[#d1d5db] line-through font-normal text-sm">{product.MRP}</span>
                        </div> */}
                    </div>
                );
            case "AGENT":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">AP: ₹ {product.AP}</div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                        </div>

                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
            case "DEALER":
                // return <span id="h3">DP: ₹ {product.DP}</span>;
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">DP: ₹ {product.DP}</div>
                            <div id="h3">MOP: ₹ {product.MOP}</div>
                        </div>

                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">Branch: {product.Branch}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                    </div>
                );
            case "JS_MANAGER":
            case "TK_MANAGER":
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        <div>
                            <div id="h3">Rate: ₹{product.RealPrateTax}</div>
                            <div id="h3">MRP: ₹ {product.MRP}</div>
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="flex flex-row justify-between items-center w-full gap-2">
                        {/* <span id="h3">MOP: ₹ {product.MOP}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
                        <div id="h3">MRP: ₹ {product.MRP}</div>
                    </div>
                );
        }
    };

    useEffect(() => {
        const fetchWishlist = async () => {
            const ledcode = localStorage.getItem("Ledcode");
            try {
                const res = await axios.get(`${apiBaseUrl}/wishlist/items/JAPAN_ACCESORIES/${ledcode}`);
                if (res.data.success && Array.isArray(res.data.items)) {
                    setWishlist(res.data.items);
                }
            } catch (err) {
                console.error("Fetch wishlist error:", err);
            } finally {
                setLoadingWishlist(false); // Important!
            }
        };

        fetchWishlist();
    }, [apiBaseUrl]);

    const getPriceByCustomerType = (product) => {
        const customerType = localStorage.getItem("CustomerType");

        switch (customerType) {
            case "CUSTOMER":
                return product.MOP;
            case "AGENT":
                return product.AP;
            case "DEALER":
                return product.DP;
            case "JS_MANAGER":
            case "TK_MANAGER":
                return product.RealPrateTax;
            case "JS_EMPLOYEE":
            case "TK_EMPLOYEE":
                return product.MRP;
            default:
                return product.MRP;
        }
    };

    const addToWishlist = async (product) => {
        const ledcode = localStorage.getItem("Ledcode");
        const price = getPriceByCustomerType(product);
        const payload = {
            ID: product.ID,
            ItemName: product.ItemName,
            MRP: price,
            ledcode: ledcode,
            Qty: 1,
            uniqueCode: 0,
        };

        try {
            const res = await axios.post(`${apiBaseUrl}/wishlist/add/JAPAN_ACCESORIES`, payload);

            if (res.data.success) {
                const newItem = {
                    ID: product.ID,
                    ItemName: product.ItemName,
                    MRP: price,
                    ledcode,
                    Qty: 1,
                    uniqueCode: 0,
                };
                setWishlist((prev) => [...prev, newItem]);

                toast.success("Added to wishlist");
                console.log(wishlist);
            } else {
                toast.error("Failed to add to wishlist");
            }
        } catch (err) {
            console.error("Add to wishlist error:", err);
            toast.error("Error adding to wishlist");
        }
    };

    const removeFromWishlist = async (productId) => {
        try {
            const res = await axios.delete(`${apiBaseUrl}/wishlist/delete/JAPAN_ACCESORIES/${productId}`);

            if (res.data.success) {
                setWishlist((prev) => prev.filter((item) => item.ID !== productId)); // Remove from local state
                toast.info("Removed from wishlist");
            } else {
                toast.error("Failed to remove from wishlist");
            }
        } catch (err) {
            console.error("Remove wishlist error:", err);
            toast.error("Error removing from wishlist");
        }
    };

    const toggleWishlist = async (product) => {
        const isInWishlist = wishlist.some((item) => item.ID === product.ID);
        if (isInWishlist) {
            await removeFromWishlist(product.ID);
        } else {
            await addToWishlist(product);
        }
    };

    return (
        <div className="h-auto flex flex-col bg-[#F7F7F7] ">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="h-[5vh] w-full mt-[1%] flex items-center lg:px-[7%] px-[2%] text-sm  font-[500] text-[#605F5F]">
                <span className="cursor-pointer text-sm  font-[500] text-[#605F5F]" onClick={categories}>
                    CATEGORIES
                </span>{" "}
                &nbsp;{">"} {Name}
            </div>

            <div className=" w-full h-auto flex flex-col justify-center items-center lg:px-[7%] px-[2%]">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 w-full mt-5">
                    {products.map((product, index) => (
                        <div
                            key={product.ID}
                            className="product-card w-full flex flex-col gap-1  rounded-md mb-4  border-[#d1d5db] bg-[white]"
                        >
                            <div
                                key={product.ID}
                                className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] gap-[2%] cursor-pointer overflow-hidden"
                            >
                                {/* Wishlist Button */}
                                {!loadingWishlist && customerType === "CUSTOMER" && (
                                    <button
                                        className="absolute top-3 right-3 text-[#d1d5db] hover:text-[red]"
                                        onClick={() => toggleWishlist(product)}
                                    >
                                        {wishlist.some((item) => item.ID === product.ID) ? (
                                            <FaHeart size={20} className="text-[red]" />
                                        ) : (
                                            <FaRegHeart size={20} />
                                        )}
                                    </button>
                                )}

                                {/* Product Image */}
                                <div
                                    onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                    className="w-[68%] h-[68%] flex justify-center items-center"
                                >
                                    <img
                                        src={`${apiLocalUrl}/uploads/${product.ID}.jpg?v=${Date.now()}`}
                                        alt={product.ItemName}
                                        className="size-[90%] object-contain mix-blend-multiply"
                                    />
                                </div>

                                {/* Add to Cart Section */}

                                <div className=" w-full text-center">
                                    <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                                        <div className="flex">
                                            <span className="text-lg font-medium">🛒</span>
                                            <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                                                Add to Cart
                                            </span>
                                        </div>

                                        <input
                                            type="text"
                                            min="1"
                                            value={quantities[product.ID] || ""}
                                            onChange={(e) => handleQuantityChange(product.ID, e.target.value)}
                                            // onBlur={() => handleBlur(product.ID)}
                                            className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                                        />
                                        <span
                                            role="button"
                                            onClick={() => handleAddToCart(product.ID)}
                                            className="cursor-pointer hover:underline"
                                        >
                                            <FaArrowAltCircleRight className="md:size-6 size-5" />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                className="w-full md:h-[18vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
                            >
                                {/* <p className="text-sm text-[#a4a7ab] mb-1">Category</p> */}
                                <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                                    {product.ItemName}
                                </span>
                                {/* Rating */}
                                {/* <div className="flex gap-1 ">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="text-[#FACC15] text-sm" />
                                    ))}
                                </div> */}

                                <div className="flex flex-row justify-between items-center w-full gap-2">
                                    <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                                        {renderPriceInfo(product)}
                                    </span>
                                    {/* <span className="text-[#d1d5db] text-sm">₹</span> */}
                                    {/* <span className="text-[#d1d5db] line-through text-sm">{product.MRP}</span> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-7">
                <Footer />
            </div>
            <ToastContainer autoClose={1500} />
        </div>
    );
}

export default Items;
